import React from 'react'
import { Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

type Props = {
  closable: boolean
  children: React.ReactNode
  onClose?: () => void
  className?: string
}

export const Modal: React.FC<Props> = ({
  closable,
  children,
  onClose,
  className
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const modalClasses = isOpen
    ? 'fixed inset-0 flex items-center justify-center z-40'
    : 'hidden'

  React.useEffect(() => {
    if (!closable) {
      setIsOpen(true)
    }
  }, [])

  return (
    <div className={classNameBuilder(modalClasses, className)}>
      <div className="fixed inset-0 opacity-100 backdrop-blur-xl backdrop:bg-[#0D0D0D]"></div>
      <div className="z-50 h-full w-full rounded-[4px] bg-white md:h-3/4 md:w-3/4">
        {children}
        {closable && (
          <button
            className="mt-4 rounded bg-gray-400 px-4 py-2 font-bold text-black hover:bg-gray-300"
            onClick={onClose}
          >
            <Text.Translated translationKey="close_modal_button" />
          </button>
        )}
      </div>
    </div>
  )
}

export default Modal
